<div class="content">
  <app-navbar></app-navbar>
  <div class="api-reference-body position-relative">
    <router-outlet></router-outlet>
    <div *ngIf="isPriceStreamingPath || isTradeStreamingPath">
      <input type="checkbox" id="check">
      <label class="chat-btn" for="check">
        <i class="bi bi-arrow-up-right-square comment"></i>
        <i class="bi bi-x-octagon close"></i>
      </label>
      <div class="wrapper" style="background-color: #eee;">
        <app-websocket-client [url]="url"></app-websocket-client>
      </div>
    </div>
  </div>
</div>

